import React from "react";
import AmenitiesContainer from "../containers/Amenities/index";

const AmenitiesPage = () => {
  return (
    <>
      <AmenitiesContainer />
    </>
  );
};

export default AmenitiesPage;
